export const TYPE_ADS = 'ads'
export const TYPE_ITEM = 'item'

export default {
  TYPE_ADS,
  TYPE_ITEM,
}
